
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M29.377 7.747c.584 2.674.584 8.253.584 8.253s0 5.579-.584 8.252c-.322 1.475-1.27 2.637-2.472 3.031C24.725 28 15.98 28 15.98 28s-8.743 0-10.924-.717c-1.203-.394-2.15-1.556-2.472-3.03C2 21.578 2 16 2 16s0-5.579.584-8.253c.322-1.475 1.27-2.636 2.472-3.03C7.236 4 15.98 4 15.98 4s8.744 0 10.925.716c1.203.395 2.15 1.556 2.472 3.031zM12.874 21.6l8.543-5.2-8.543-5.2v10.4z"}})])
      }
    
      }
    